import {rgElement} from '../rgElement/rg-element.js';

const setup = function(nav) {
        if(!this.offcanvasNav) {
            let config = this.defaultConfig;
            for(const [key, value] of Object.entries(this.defaultConfig)) {
                let attribute = this.getAttribute('data-' + key);
                if(attribute) {
                    config[key] = this.parseAttribute(attribute);
                }
            }
            this.toggleButton.addEventListener('click', function() {
                let evt = new KeyboardEvent('keydown', {
                    keyCode: 13
                });
                this.dispatchEvent(evt);
            });
            config.customToggle = this.toggleButton;
            this.offcanvasNav = new hcOffcanvasNav(this.mode === 'dropdown' ? this.firstElementChild : this.wrapper.firstElementChild, config);
            this.templates.forEach((tpl) => {
                let target = document.querySelector(tpl.dataset.target),
                    dynamic = this.parseAttribute(tpl.dataset.dynamic);
                if(target) {
                    let tag = document.createElement('div');
                    tag.classList.add(tpl.dataset.wrapperclass);
                    tag.append(tpl.content);
                    switch(tpl.dataset.operation) {
                        case 'append':
                            target.append(tag);
                            break;
                        case 'prepend':
                            target.prepend(tag);
                            break;
                    }
                    if(dynamic) {
                        this.offcanvasNav.on('open.level', moveNode.bind(tpl, target, tag));
                        this.offcanvasNav.on('close.level', moveNode.bind(tpl, target, tag));
                    }
                }
            });
            if(config.closeOpenLevels === false) {
                try {
                    let currentLink = this.offcanvasNav.querySelector('a[href^="' + document.location.pathname.split('/').filter(p => {
                            return !p.match('.html')
                        }).join('/') + '"]')?.closest('*[data-index]'),
                        dataLevel = Number(currentLink?.getAttribute('data-level')),
                        dataIndex = Number(currentLink?.getAttribute('data-index'));
                    if(dataLevel) {
                        //some external stylesheets may be animating things... give them some time
                        window.setTimeout(function() {
                            //if found... open it
                            this.offcanvasNav.style.display = 'none';
                            this.offcanvasNav.open(dataLevel, dataIndex);
                            this.offcanvasNav.close();
                            this.offcanvasNav.style.display = '';
                        }.bind(this), 100);
                    }
                } catch(ex) {
                }
            }
            this.offcanvasNav.on('open', () => {
                if(config.closeOpenLevels === false) {
                    this.offcanvasNav.querySelector('a[href="' + document.location.pathname + '"], a[href="' + document.location.pathname + 'index.html"]')?.focus()
                } else {
                    this.offcanvasNav.querySelector('ul a')?.focus()
                }
                document.dispatchEvent(new CustomEvent('rgnav:open', {
                    detail: {el: this}
                }));
            });
        }
    },
    moveNode = function(navEl, elemtag, ev, n) {
        let panel = navEl.querySelector('div[data-level="' + ev.data.currentLevel + '"][data-index="' + ev.data.currentIndex + '"]'),
            newTarget = panel ? panel.querySelector(this.dataset.target) : navEl;
        switch(this.dataset.operation) {
            case 'append':
                newTarget.append(elemtag);
                break;
            case 'prepend':
                newTarget.prepend(elemtag);
                break;
        }
    },
    buildMegamenu = function() {
        let $megamenu = document.createElement('nav');
        $megamenu.classList.add('megamenu');
        $megamenu.setAttribute('aria-role', 'menu');
        const $menuDataUl = this.querySelector('ul');
        $megamenu.append(buildSubmenu.call(this, $menuDataUl, 0));
        return $megamenu;
    },
    buildSubmenu = function($menuDataUl, level, $overviewLink = null) {
        const $ul = document.createElement('ul');
        $ul.classList.add('megamenu--level' + level);
        if(level > 0) {
            $ul.classList.add('megamenu__submenu');
            $ul.setAttribute('aria-role', 'menu');
            $ul.setAttribute('aria-hidden', 'true');
        } else {
            $ul.classList.add('megamenu__mainmenu');
            $ul.setAttribute('aria-role', 'menubar');
        }
        $ul.setAttribute('data-level', level);
        if($overviewLink) {
            const $li = document.createElement('li');
            const $element = $overviewLink.cloneNode(true);
            $element.classList.add('megamenu__entry');
            $element.setAttribute('aria-role', 'menuitem');
            $element.innerHTML = 'Übersicht';
            $li.append($element);
            $ul.append($li);
        }
        Array.from($menuDataUl.children).forEach($menuDataLi => {
            let $nextOverviewLink = null;
            const $li = document.createElement('li');
            let hasSubmenu = ($menuDataLi.querySelector(':scope > ul') !== null);
            Array.from($menuDataLi.children).forEach($menuDataElement => {
                if($menuDataElement.tagName !== 'UL') {
                    let $element;
                    if(hasSubmenu && $menuDataElement.tagName === 'A') {
                        $nextOverviewLink = $menuDataElement;
                        $element = document.createElement('span');
                        $element.innerHTML = $menuDataElement.innerHTML;
                    } else {
                        $element = $menuDataElement.cloneNode(true);
                    }
                    $element.classList.add('megamenu__entry');
                    $element.setAttribute('aria-role', 'menuitem');
                    if($element.tagName === 'SPAN') {
                        $element.setAttribute('aria-haspopup', 'menu');
                        $element.setAttribute('aria-expanded', 'false')
                    }
                    $li.append($element);
                } else {
                    $li.classList.add('megamenu--has_submenu');
                    hasSubmenu = true;
                    const $arrow = document.createElement('i');
                    $arrow.classList.add('megamenu__arrow');
                    $arrow.classList.add('fas');
                    $arrow.setAttribute('tabindex', 0);
                    $arrow.setAttribute('aria-haspopup', 'menu');
                    $arrow.setAttribute('aria-expanded', 'false')
                    $li.append($arrow);
                    const $submenu = buildSubmenu.call(this, $menuDataElement, level + 1, $nextOverviewLink);
                    if(level === 0 && $menuDataLi.dataset.extracontentid) {
                        const $extracontent_template = this.querySelector('.megamenu-extracontent-template[data-extracontentid="' + $menuDataLi.dataset.extracontentid + '"]');
                        if($extracontent_template) {
                            const $extracontent_li = document.createElement('li');
                            $extracontent_li.classList.add('megamenu__extracontent-container');
                            const extracontent_copy = $extracontent_template.cloneNode(true);
                            extracontent_copy.classList.remove('megamenu-extracontent-template');
                            $extracontent_li.append(extracontent_copy);
                            $ul.append($extracontent_li);
                            $submenu.append($extracontent_li);
                        }
                    }
                    $li.append($submenu)
                }
            });
            if(hasSubmenu) {
                $li.addEventListener('pointerdown', event => megamenuClickhandler.call(this, event));
                $li.addEventListener('keydown', event => {
                    if(event.code === 'Enter') {
                        megamenuClickhandler.call(this, event);
                    }
                    if(event.code === 'Escape') {
                        document.querySelectorAll('.megamenu--level0 > li.megamenu--open').forEach($element => {
                            $element.dispatchEvent(new PointerEvent('pointerdown', {
                                view: window,
                                bubbles: false,
                                cancelable: true
                            }))
                        })
                    }
                });
            }
            $ul.append($li);
        });
        return $ul;
    },
    megamenuClickhandler = function(event) {
        if(event.type === 'pointerdown' && event.pointerType === 'mouse' && event.buttons !== 1) {
            return;
        }
        console.log(event);
        if(event.target.tagName === "A") {
            return;
        }
        const $target = event.currentTarget;
        let mode;
        const $submenu = $target.querySelector('ul');
        if($target.classList.contains('megamenu--open')) {
            mode = 'closing';
            megamenuCloseSubmenu.call(this$target);
            if($target.parentNode.classList.contains('megamenu--level0')) {
                document.querySelectorAll('.megamenu__overlay').forEach($overlay => $overlay.remove());
            }
        } else {
            mode = 'opening';
            const $$siblings = $target && $target.parentNode && [...$target.parentNode.children].filter(node => node !== $target && node.classList.contains('megamenu--open'));
            $$siblings.forEach($element => {
                megamenuCloseSubmenu.call(this$element);
            })
            $target.classList.add('megamenu--open');
            $target.querySelectorAll(':scope > span, :scope > i').forEach($element => {
                $element.setAttribute('aria-expanded', 'true');
            });
            $submenu.setAttribute('aria-hidden', 'false');
            if($target.parentNode.classList.contains('megamenu--level0')) {
                document.querySelectorAll('.megamenu__overlay').forEach($overlay => $overlay.remove())
                const $overlay = document.createElement('div');
                $overlay.classList.add('megamenu__overlay');
                $target.append($overlay);
            }
        }
        if(!this.megamenuSubmenuSizes.has($submenu)) {
            this.megamenuSubmenuSizes.set($submenu, $submenu.offsetHeight);
            $submenu.classList.add('megamenu--expand-submenu');
        }
        const megamenuPadding = parseInt(getComputedStyle($target).getPropertyValue('--megamenu-padding'));
        const $extracontentContainer = $target.parentNode.classList.contains('megamenu--level0') ?
                                       $target.querySelector('.megamenu__extracontent-container') :
                                       $target.closest('.megamenu--level1')?.querySelector('.megamenu__extracontent-container');
        let extracontentContainerHeight = '';
        if($extracontentContainer) {
            extracontentContainerHeight = $extracontentContainer.offsetHeight;
        }
        if(!$target.parentNode.classList.contains('megamenu--level0')) {
            if(mode === 'opening') {
                this.megamenuOpenSubmenus.set($submenu, $submenu);
            }
            let maxSize = extracontentContainerHeight;
            this.megamenuOpenSubmenus.forEach($submenu => {
                if(this.megamenuSubmenuSizes.get($submenu) > maxSize) {
                    maxSize = this.megamenuSubmenuSizes.get($submenu);
                }
            })
            if($target.closest('.megamenu--level1').offsetHeight < maxSize + 2 * megamenuPadding) {
                $target.closest('.megamenu--level1').style.minHeight = (maxSize + 2 * megamenuPadding) + 'px';
            } else {
                window.setTimeout(() => {
                    $target.closest('.megamenu--level1').style.minHeight = (maxSize + 2 * megamenuPadding) + 'px';
                }, 300)
            }
        } else {
            $target.querySelector('.megamenu--level1').style.minHeight = (extracontentContainerHeight + 2 * megamenuPadding) + 'px';
        }
        event.cancelBubble = true;
    },
    megamenuCloseSubmenu = function($target) {
        $target.classList.remove('megamenu--open');
        $target.querySelector('ul').setAttribute('aria-hidden', 'true');
        $target.querySelectorAll(':scope > span, :scope > i').forEach($element => {
            $element.setAttribute('aria-expanded', 'false');
        });
        this.megamenuOpenSubmenus.delete($target.querySelector('ul'));
        $target.querySelectorAll('.megamenu--open').forEach($element => {
            $element.classList.remove('megamenu--open');
            $element.setAttribute('aria-expanded', 'false')
            $element.querySelectorAll(':scope > span, :scope > i').forEach($element => {
                $element.setAttribute('aria-expanded', 'false');
            });
            $element.querySelector('ul').setAttribute('aria-hidden', 'true');
            this.megamenuOpenSubmenus.delete($element.querySelector('ul'));
        })
    },
    connected = function() {
        if(!this.querySelectorAll('ul').length) {
            return;
        }
        let adoptedCssCode = this.getStyles('.rg-nav', '.rg-nav-wrapper');
        const fontColor = adoptedCssCode.match(/color:(.*?);/)
        if(fontColor) {
            adoptedCssCode = adoptedCssCode + ' .hc-nav-trigger {--nav-trigger-color: ' + fontColor[1] + '}';
        }
        const adoptedCSS = document.createElement('style');
        adoptedCSS.innerHTML = adoptedCssCode;
        /**
         * search for custom templates to append or prepend to navigation-html (see "setup")
         */
        this.templates = this.querySelectorAll('template');
        /**
         * create elements and load required files
         */
        const offcanvasCss = document.createElement('link');
        offcanvasCss.setAttribute('rel', 'stylesheet');
        offcanvasCss.setAttribute('href', 'https://cdn.regiogate.net/hc-offcanvas-nav/hc-offcanvas-nav.css');
        let customCss = '';
        if(this.dataset.customcss) {
            customCss = document.createElement('link');
            customCss.setAttribute('rel', 'stylesheet');
            customCss.setAttribute('href', this.dataset.customcss);
        }
        if(this.dataset.mode) {
            this.mode = this.dataset.mode;
        }
        const linkElem = document.createElement('link');
        linkElem.setAttribute('rel', 'stylesheet');
        linkElem.setAttribute('href', this.rootpath + '/css/rg-nav.css');
        const offCanvasScript = document.createElement('script');
        this.wrapper = document.createElement('div');
        const $slot = document.createElement('slot')
        this.wrapper.append($slot);
        this.wrapper.setAttribute('class', 'rg-nav-wrapper');
        this.classList.forEach(classname => {
            if(classname !== 'rg-nav') {
                this.wrapper.classList.add(classname);
            }
        })
        if(this.dataset.customtoggle !== undefined) {
            this.toggleButton = document.querySelector(this.dataset.customtoggle)
        } else {
            this.toggleButton = document.createElement('a');
            this.toggleButton.setAttribute('href', '#');
            this.toggleButton.setAttribute('class', 'hc-nav-trigger fas fa-bars');
            this.toggleButton.append(document.createElement('span'));
        }
        document.head.append(offcanvasCss, customCss);
        switch(this.mode) {
            case 'dropdown':
                //nav remains in light dom, slotted in. Should become default, but needs css adaptations...
                break;
            case 'megamenu':
                this.wrapper.innerHTML = this.innerHTML + this.wrapper.innerHTML;
                const $megamenu = buildMegamenu.call(this);
                this.innerHTML = '';
                this.append($megamenu);
                break;
            default:
                this.wrapper.innerHTML = this.innerHTML + this.wrapper.innerHTML;
                this.innerHTML = '';
        }
        if(this.dataset.customtoggle === undefined) {
            this.wrapper.append(this.toggleButton);
        }
        this.shadowRoot.append(linkElem, adoptedCSS, offCanvasScript, this.wrapper);
        /**
         * as offcanvas-script is loaded run setup
         */
        offCanvasScript.onload = function() {
            setup.call(this);
            this.style.display = '';
            if(this.toggleButton.querySelector('.menu-button__icon')) {
                this.toggleButton.classList.remove('hc-nav-trigger');
            }
        }.bind(this);
        offCanvasScript.src = 'https://cdn.regiogate.net/hc-offcanvas-nav/hc-offcanvas-nav.js';
        this.setupComplete();
    }

/*
 * exports
 */
export class rgNav extends rgElement {
    defaultConfig = {
        width: 280,
        height: 'auto',
        disableAt: false,
        pushContent: null,
        swipeGestures: true,
        expanded: false,
        position: 'right', // left, right, top, botto,
        levelOpen: 'overlap', // overlap, expand, none/fals,
        levelSpacing: 40,
        levelTitles: true,
        closeOpenLevels: false,
        closeActiveLevel: false,
        navTitle: null,
        navClass: '',
        disableBody: true,
        closeOnClick: true,
        closeOnEsc: true,
        activeToggleClass: null,
        bodyInsert: 'prepend', // prepend/appen,
        keepClasses: true,
        removeOriginalNav: false,
        rtl: false,
        insertClose: true,
        insertBack: true,
        levelTitleAsBack: true,
        labelClose: '',
        labelBack: 'Back',
    };
    toggleButton = null;
    wrapper = null;
    templates = [];
    mode = "default";
    megamenuSubmenuSizes = new Map();
    megamenuOpenSubmenus = new Map();

    constructor() {
        super();
    }

    connectedCallback() {
        this.setUpElement();
        this.offcanvasNav = null;
        this.attachShadow({mode: 'open'});
        this.style.display = 'none';
        if(document.readyState === 'complete') {
            connected.call(this);
        } else {
            window.addEventListener('load', connected.bind(this))
        }
        document.addEventListener('rgsearch:show', this.hideNav.bind(this));
    }

    showNav() {
        this.offcanvasNav && this.offcanvasNav.open();
        document.dispatchEvent(new CustomEvent('rgnav:open', {
            detail: {el: this}
        }));
    }

    hideNav() {
        this.offcanvasNav && this.offcanvasNav.close();
    }

    toggleNav() {
        if(this.offcanvasNav) {
            this.offcanvasNav.toggle();
            if(this.offcanvasNav.isOpen()) {
                document.dispatchEvent(new CustomEvent('rgnav:open', {
                    detail: {el: this}
                }));
            }
        }
    }

    isOpen() {
        return this.offcanvasNav ? this.offcanvasNav.isOpen() : false;
    }
}